import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "cus-input inline-flex relative"
};
import { ref, computed, onUnmounted } from 'vue';
import { useResizeObserver } from '@vueuse/core'; // 修改导入
export default /*@__PURE__*/_defineComponent({
  __name: 'cusInput',
  props: {
    maxWidth: {},
    placeholder: {
      default: '请输入'
    },
    modelValue: {}
  },
  setup(__props, {
    expose: __expose
  }) {
    _useCssVars(_ctx => ({
      "v12345b80": minWidth.value
    }));
    const compositionVal = ref('');
    // 修改后的尺寸监听逻辑
    const measureRef = ref(null);
    const placeholderWidth = ref(0);
    const {
      stop
    } = useResizeObserver(measureRef, entries => {
      const entry = entries[0];
      placeholderWidth.value = entry.contentRect.width;
    });
    const minWidth = computed(() => {
      return `${Math.max(placeholderWidth.value || 52, 52)}px`;
    });
    const handleCompositionUpdate = e => {
      compositionVal.value = e.data || '';
    };
    const handleCompositionEnd = e => {
      compositionVal.value = '';
    };
    const inputRef = ref(null);
    // 添加组件卸载时的清理
    onUnmounted(() => {
      stop(); // 现在可以正确停止监听
    });
    __expose({
      focus: () => {
        inputRef.value?.focus();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
        ref_key: "measureRef",
        ref: measureRef,
        class: "cus-input-measure",
        style: _normalizeStyle({
          maxWidth: __props.maxWidth ? __props.maxWidth + 'px' : 'none'
        })
      }, _toDisplayString(__props.modelValue + compositionVal.value || __props.placeholder), 5), _createVNode(_component_el_input, _mergeProps({
        ref_key: "inputRef",
        ref: inputRef,
        "model-value": __props.modelValue,
        placeholder: __props.placeholder
      }, _ctx.$attrs, {
        onCompositionupdate: handleCompositionUpdate,
        onCompositionend: handleCompositionEnd
      }), null, 16, ["model-value", "placeholder"])]);
    };
  }
});